<p-card class="card-spacing-0">
  <span
    class="d-flex justify-content-between align-items-center globalborder-btm-header mb-3 pb-2 px-0"
    *ngIf="!fromSummary">
    <span class="col-auto d-flex gap-2">
      <h2 class="mb-0">Order Notes</h2>
    </span>
    <span>
      <span class="cross-border" (click)="onCloseModal()"
        ><i class="pi pi-times"></i
      ></span>
    </span>
  </span>
  <div class="orders-list">
    <p-table
      #dt
      stripedRows
      [rowHover]="true"
      [rows]="25"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      [size]="'small'"
      styleClass="table-listing"
      responsiveLayout="scroll"
      [value]="orderNotesGridListing"
      [(selection)]="selectedOrderNotesGridListing"
      [rowHover]="true"
      [rows]="20"
      [showCurrentPageReport]="true"
      [paginator]="false"
      [filterDelay]="0"
      dataKey="id"
      editMode="row"
      selectionMode="multiple">
      <ng-template pTemplate="header">
        <tr class="table-head">
          <th></th>
          <th class="col-center">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th class="number">Type</th>
          <th class="name">Description</th>
          <th class="name">Note</th>
          <th class="name">Created By</th>
          <th class="name">Created date</th>
          <th class="name">Modified By</th>
          <th class="name">Modified date</th>
        </tr>
        <tr>
          <th></th>
          <th></th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="type"
                id="type"
                (input)="
                  dt.filter($any($event.target).value, 'type', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="description"
                id="description"
                (input)="
                  dt.filter(
                    $any($event.target).value,
                    'description',
                    'contains'
                  )
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="note"
                id="note"
                (input)="
                  dt.filter($any($event.target).value, 'note', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th>
            <div class="d-flex">
              <input
                jniAutoCompleteBlocker
                pInputText
                type="text"
                name="createdBy"
                id="createdBy"
                (input)="
                  dt.filter($any($event.target).value, 'createdBy', 'contains')
                "
                placeholder=""
                class="p-column-filter p-inputtext p-component" />
            </div>
          </th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-orderNotesGridListing
        let-editing="editing"
        let-rowIndex="rowIndex">
        <tr
          class="p-selectable-row"
          [pEditableRow]="orderNotesGridListing"
          [pSelectableRow]="orderNotesGridListing"
          [ngClass]="{ 'line-gray': !orderNotesGridListing?.isActive }"
          [pSelectableRowDisabled]="!orderNotesGridListing?.isActive">
          <td>
            <button
              *ngIf="!editing"
              [disabled]="!orderNotesGridListing?.isActive"
              pButton
              pRipple
              type="button"
              pInitEditableRow
              (click)="onEditRow(orderNotesGridListing)"
              icon="pi pi-pencil"
              class="p-button-rounded p-button-text"></button>
            <button
              *ngIf="editing"
              [disabled]="!orderNotesGridListing?.isActive"
              pButton
              pRipple
              type="button"
              pSaveEditableRow
              (click)="onRowEditSave(orderNotesGridListing)"
              icon="pi pi-check"
              class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color"></button>
            <button
              *ngIf="editing"
              [disabled]="!orderNotesGridListing?.isActive"
              pButton
              pRipple
              type="button"
              pCancelEditableRow
              (click)="getQuoteNotes(this.quoteId)"
              icon="pi pi-times"
              class="p-button-rounded p-button-text p-button-danger"></button>
          </td>
          <td class="col-center">
            <p-tableCheckbox
              [pSelectableRow]="orderNotesGridListing"
              [value]="orderNotesGridListing"></p-tableCheckbox>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  id="currency"
                  [(ngModel)]="orderNotesGridListing.type"
                  (change)="
                    onPurchaseorderchange(
                      orderNotesGridListing.type,
                      orderNotesGridListing.id
                    )
                  "
                  [options]="typeList"
                  optionLabel="name"
                  optionValue="name">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ orderNotesGridListing.type }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="orderNotesGridListing.description"
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ orderNotesGridListing.description }}
                <i
                  class="link icon-BCledger"
                  *ngIf="orderNotesGridListing?.attachmentURL"
                  (click)="
                    redirectToAttachment(orderNotesGridListing?.attachmentURL)
                  ">
                </i>
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="orderNotesGridListing.note"
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ orderNotesGridListing.note }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>{{ orderNotesGridListing.createdBy }}</td>
          <td>
            <span *ngIf="orderNotesGridListing?.createdDate | hidedynamicsdate">
              {{ orderNotesGridListing.createdDate | date: "MM-dd-yyyy" }}
            </span>
          </td>
          <td>{{ orderNotesGridListing.lastModifiedBy }}</td>
          <td>
            {{ orderNotesGridListing.lastModifiedDate | date: "MM-dd-yyyy" }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-card>
